import { DocumentModel } from '../app/core/models/document-model';

/**
 * Mock-Daten für Dokumente.
 * guid-Feld entspricht dem neuen API-Format.
 * uri enthält den Dokumentpfad.
 * checks-Array enthält verschachtelte Check-GUIDs (wie sie die API zurückliefert).
 */
export const DOCUMENT: DocumentModel[] = [
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000001',
    uri: '/docs/file1.pdf',
    displayName: 'Document Alpha',
    checks: [
      { guid: 'aaaaaaaa-0000-0000-0000-000000000001', createdAt: '2025-03-10T00:00:00Z', description: 'Elektrikprüfung Leitungsanlage' },
      { guid: 'aaaaaaaa-0000-0000-0000-000000000002', createdAt: '2025-03-20T00:00:00Z', description: 'Wasserabflussprüfung Brückenentwässerung' },
    ],
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000002',
    uri: '/docs/file2.pdf',
    displayName: 'Document Beta',
    checks: [
      { guid: 'aaaaaaaa-0000-0000-0000-000000000001', createdAt: '2025-03-10T00:00:00Z', description: 'Elektrikprüfung Leitungsanlage' },
      { guid: 'aaaaaaaa-0000-0000-0000-000000000002', createdAt: '2025-03-20T00:00:00Z', description: 'Wasserabflussprüfung Brückenentwässerung' },
    ],
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000003',
    uri: '/docs/file3.pdf',
    displayName: 'Document Gamma',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000004',
    uri: '/docs/file4.pdf',
    displayName: 'Document Delta',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000005',
    uri: '/docs/file5.pdf',
    displayName: 'Document Epsilon',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000006',
    uri: '/docs/file6.pdf',
    displayName: 'Document Zeta',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000007',
    uri: '/docs/file7.pdf',
    displayName: 'Document Eta',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000008',
    uri: '/docs/file8.pdf',
    displayName: 'Document Theta',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000009',
    uri: '/docs/file9.pdf',
    displayName: 'Document Iota',
  },
  {
    guid: 'bbbbbbbb-0000-0000-0000-000000000010',
    uri: '/docs/file10.pdf',
    displayName: 'Document Kappa',
  },
];

/**
 * Mock-Dokumente für Check aaaaaaaa-0000-0000-0000-000000000001.
 * Wird vom Interceptor bei GET /api/check/{guid}/document zurückgegeben.
 */
export const DOCUMENTS_FOR_CHECK: Record<string, DocumentModel[]> = {
  'aaaaaaaa-0000-0000-0000-000000000001': [
    { guid: 'bbbbbbbb-0000-0000-0000-000000000001', uri: '/docs/file1.pdf', displayName: 'Document Alpha' },
    { guid: 'bbbbbbbb-0000-0000-0000-000000000002', uri: '/docs/file2.pdf', displayName: 'Document Beta' },
  ],
  'aaaaaaaa-0000-0000-0000-000000000002': [
    { guid: 'bbbbbbbb-0000-0000-0000-000000000001', uri: '/docs/file1.pdf', displayName: 'Document Alpha' },
    { guid: 'bbbbbbbb-0000-0000-0000-000000000002', uri: '/docs/file2.pdf', displayName: 'Document Beta' },
  ],
};


